module.exports = __webpack_public_path__ + "static/media/design-designers-dribbble-svgrepo-com.9d1c006b.svg";